import React, { PropTypes } from 'react';
import EntityItem from './EntityItem';

const EntityList = ({ info, link, entities, select }) => {
  if (entities.length) {
    return (
      <div>
        <div className="ui info message">{info}</div>
        <table className="ui very basic table">
          <tbody>
            {entities.map(entity => (
              <EntityItem key={entity.id} entity={entity} onSelect={select} />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="ui message">
      Aucun élément. Veuillez en ajouter un via{' '}
      <a href={link}>l'utilitaire de gestion des données</a>
    </div>
  );
};

EntityList.propTypes = {
  info: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  entities: PropTypes.array.isRequired,
  select: PropTypes.func.isRequired,
};

export default EntityList;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/EntityList.js